<template>
  <div>
    <v-dialog v-model="dialog" persistent width="400px">
      <v-form ref="form" v-model="valid" autocomplete="off">
        <v-card>
          <v-card-title>
            パスワード変更
            <v-spacer></v-spacer>
            <v-btn v-if="!mustChangePassword" icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row class="mx-2">
              <v-col cols="12" class="text-right mt-n5">
                <span class="error--text">* </span>
                <span>は必須項目</span>
              </v-col>
            </v-row>

            <v-row class="mx-2">
              <v-col cols="12">
                <v-text-field
                  type="password"
                  v-model="newpassword"
                  id="newpassword"
                  :rules="rules.passwordRule"
                  required
                  size="20"
                >
                  <template v-slot:label>
                    <span>新しいパスワード</span>
                    <span class="error--text"> *</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  type="password"
                  v-model="confirmpassword"
                  id="confirmpassword"
                  :rules="rules.passwordConfirmationRule"
                  required
                  size="20"
                >
                  <template v-slot:label>
                    <span>新しいパスワード再入力</span>
                    <span class="error--text"> *</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions class="gray">
            <v-spacer />
            <v-btn color="primary" class="px-4" elevation="2" @click="save">登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PasswordChange",
  data: () => ({
    dialog: false,
    valid: true,
    newpassword: "",
    confirmpassword: "",
    rules: {},
  }),
  computed: {
    ...mapState(["user"]),
    mustChangePassword() {
      return this.user.needToChangePassFlag;
    },
    passwordEqualRule() {
      return () =>
        this.newpassword === this.confirmpassword ||
        "入力したパスワードが一致しません。";
    },
    defaultPasswordRule() {
      return () =>
        this.newpassword !== this.user.defaultPassword ||
        "入力されたパスワードは初期値のため使えません。";
    },
  },
  created() {
    this.setRules();
  },
  methods: {
    setRules() {
      this.rules = {
        passwordRule: [
          this.$getValidate("required", "パスワード"),
          this.$getValidate("passwordPatternRule"),
          this.defaultPasswordRule,
        ],
        passwordConfirmationRule: [
          this.$getValidate("required", "パスワード"),
          this.passwordEqualRule,
        ],
      };
    },
    open() {
      setTimeout(() => {
        this.$refs.form.reset();
      }, 500);
      this.dialog = true;
    },
    async save() {
      if (this.$refs.form.validate()) {
        window.openLoading();
        const data = await this.$api.changePassword({
          password: this.newpassword,
        });
        window.closeLoading();
        if (data && data.status == 200) {
          this.user.needToChangePassFlag = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
